// ---------------------------------------------------------------------------
// Params
// ---------------------------------------------------------------------------

export interface DotPlotParams {
  /** Raw data values */
  readonly data: number[];
}

// ---------------------------------------------------------------------------
// Display
// ---------------------------------------------------------------------------

export interface DotPlotDisplayConfig {
  readonly dotColor?: string;
  /** Dot diameter in pixels */
  readonly dotSize?: number;
}

export const DEFAULT_DOT_PLOT_DISPLAY: DotPlotDisplayConfig = {
  dotColor: '#6366f1', // indigo-500
  dotSize: 10,
};
